import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";
import Text from "components/atoms/Text";
import { PrescriptionHospitalGroup } from "common/models/types";
import PrescriptionGroupCard from "./PrescriptionGroupCard";

interface PrescriptionHospitalGroupCardProps {
  hospitalGroup: PrescriptionHospitalGroup;
  referenceChecker?: {
    [id: string]: {
      count: number;
      totalLength?: number;
      totalBytes?: number;
    };
  };
  onEdit?: (groupId: string) => void;
  onDelete?: (groupId: string) => void;
  /** 읽기전용(보고서화면): 수정/삭제 버튼 미렌더 */
  readOnly?: boolean;
}

const Container = styled.div`
  margin-bottom: 24px;
`;

const HospitalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 12px 16px;
  background: ${COLOR_SYSTEM.get("Blue")[50]};
  border-radius: 8px;
  border-left: 4px solid ${COLOR_SYSTEM.get("Blue")[400]};
`;

const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 16px;
`;

const PrescriptionHospitalGroupCard: React.FC<PrescriptionHospitalGroupCardProps> = ({
  hospitalGroup,
  referenceChecker,
  onEdit,
  onDelete,
  readOnly,
}) => {
  return (
    <Container>
      <HospitalHeader>
        <Text textType="H4" color={COLOR_SYSTEM.get("Blue")[600]} style={{ fontWeight: 600 }}>
          {hospitalGroup.hospital || "병원명 없음"}
        </Text>
        <Text textType="Body2" color={COLOR_SYSTEM.get("Gray")[500]}>
          ({hospitalGroup.prescriptionGroups.length}개 처방전)
        </Text>
      </HospitalHeader>
      <GroupsContainer>
        {hospitalGroup.prescriptionGroups.map((group) => (
          <PrescriptionGroupCard
            key={group.groupId}
            group={group}
            referenceChecker={referenceChecker}
            onEdit={onEdit}
            onDelete={onDelete}
            hideHospital={true}
            readOnly={readOnly}
          />
        ))}
      </GroupsContainer>
    </Container>
  );
};

export default PrescriptionHospitalGroupCard;